'use client';

import Button from 'molecules/Button';

import styles from 'components/HealthcareEntries/LearningCenterIndicator/learning-center.module.scss';

import type { FC } from 'react';

interface LearningCenterIndicatorProps {
  slug: string;
  isHCIOnly: boolean;
}

const domain = process.env.NEXT_PUBLIC_LEARNING_CENTER_SITE_DOMAIN || 'https://learning.magmutual.com';

const LearningCenter: FC<LearningCenterIndicatorProps> = ({ slug, isHCIOnly }) => {
  const url = isHCIOnly ? `${domain}/content-library` : `${domain}${slug}`;

  return (
    <>
      <section aria-label="Learning Center" className={styles.learningCenterContainer}>
        <h5 className={styles.learningCenterHeader}>LEARNING CENTER / CMEs</h5>
        <p className={styles.learningCenterDescription}>
          Policyholders can access their CME credits in the MyMagMutual Learning Center.
        </p>
        <Button url={url} className={styles.myMagMutualLink} color="gray" target="_self">
          MyMagMutual
        </Button>
      </section>
    </>
  );
};

export default LearningCenter;
